import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppLocale } from '../../../i18n/localeUtils'
import { IssueEntity } from 'types/IssueEntity'
import { formatDateYYYYMMDD } from '../../../packages/utils/numberFormatters'
import { FactsTableRow } from '../../components/FactsTable'

export function PublicationDateRow({ issue }: { issue: IssueEntity }) {
    const { t } = useTranslation()
    const { language } = useAppLocale()
    const publicationDate = issue.sources?.find((s) => s.sourceType === 'Publication')?.publishedDate

    return (
        <FactsTableRow label={t('pages.issues.terms.publicationDate')}>
            {formatDateYYYYMMDD(publicationDate, { locale: language })}
        </FactsTableRow>
    )
}
